export default __webpack_public_path__ + "fe475c3e9b12f4e66624c7b6cc76d0a9.png";